import { useFormContext } from 'react-hook-form';

import type { QBankStructureLevelFormInput } from './qbank-structure-level-form-schema';

export const useQBankStructureLevelFormContext = useFormContext<QBankStructureLevelFormInput>;
